export const collegesNameList = [
    'MAHARANI LAXMI AMMANI WOMENS COLLEGE',
    'SESHADRIPURAM FIRST GRADE COLLEGE',
    'ACHARYA INSTITUTE OF GRADUATE STUDIES',
    'EAST WEST COLLEGE OF BUSINESS MANAGEMENT',
    'BASAVESHWARA COLLEGE',
    'CMR INSTITUTE OF MANAGEMENT STUDIES',
    'DAYANANDA SAGAR INSTITUTIONS (DIS)',
    'AIMS',
    'SURANA COLLEGE',
    'ADICHUNCHUNAGIRI',
    'NEW HORIZON',
    'VIVEKANANDA DEGREE COLLEGE',
    'SAMBHRAM ACADEMY OF MANAGEMENT STUDIES',
    'JAIN COLLEGE, V V PURAM',
    'S.J.R.C. COLLEGE FOR WOMEN',
    'MALLESHWARAM WOMEN\'S ASSOCIATION FIRST GRADE COLLEGE - MALLESHWARAM, BANGALORE',
    'THE OXFORD COLLEGE OF SCIENCE, BUSINESS MANAGEMENT, ARTS AND LAW',
    'INDIAN ACADEMY',
    'GOVERNMENT SCIENCE COLLEGE',
    'BALDWIN\'S WOMEN\'S METHODIST COLLEGE',
    'MS RAMAIAH POLYTECHNIC COLLEGE',
    'GOVERNMENT FIRST GRADE COLLEGE , KRISHNARAJAPURAM',
    'SESHADRIPURAM INSTITUTE OF COMMERCE AND MANAGEMENT',
    'SESHADRIPURAM PU COLLEGE',
    'NATIONAL COLLEGE,JAYANAGAR',
    'CITY COLLEGE, JAYANAGAR',
    'NATIONAL COLLEGE, BASAVANAGUDI',
    'NARSEE MONJEE INSTITUTE OF MANAGEMENT STUDIES ',
    'ST JOSEPH\'S COLLEGE OF COMMERCE - [SJCC]',
    'BMS COLLEGE OF ENGINEERING - MBA DEPT',
    'KRISTU JAYANTI - MBA',
    'CHRIST UNIVERSITY',
    'SESHADRIPAM ACADEMY OF BUSINESS STUDIES',
    'ALLIANCE SCHOOL OF BUSINESS',
    "REVA INSTITUTE OF SCIENCE AND MANAGEMENT",
    "ACHARYA BANGALORE B SCHOOL",
    "ST.CLARET COLLEGE",
    'NRI INSTITUTE',
    'C.B.BHANDARI JAIN COLLEGE',
    'UNITED MISSION DEGREE COLLEGE',
    'ST. ANNE\'S DEGREE COLLEGE',
    'HASANTH COLLEGE',
    'BET INSTITUTE OF MANAGEMENT STUDIES',
    'ST.GEORGE COLLEGE',
    'SOUNDARAYA INSTITUTE OF MANAGEMENT & SCIENCE (SIMS)',
    'NMKRV COLLEGE FOR WOMEN, BANGALORE',
    'RAMANASHREE ACADEMY OF MANAGEMENT',
    'R P A FIRST GRADE COLLEGE',
    'NOBLE INSTITUTE OF EDUCATION SOCIETY ',
    'VIDYA SANSKAAR INSTITUTE OF SCIENCE, COMMERCE & MANAGEMENT',
    'KARNATAKA COLLEGE OF MANAGEMENT & SCIENCE - [KCMS]',
    'SRI VENKATESHWARA EDUCATIONAL INSTITUTION',
    'GLOBAL INSTITUTE OF MANAGEMENT SCIENCES',
    'A P S COLLEGE OF ENGINEERING',
    'A.M.C. ENGINEERING COLLEGE',
    'ACHARYA INSTITUTE OF TECHNOLOGY',
    'ACS COLLEGE OF ENGINEERING',
    'ADARSHA INSTITUTE OF TECHNOLOGY',
    'ALPHA COLLEGE OF ENGINEERING',
    'AMRITA SCHOOL OF ENGINEERING',
    'ATME COLLEGE OF ENGINEERING',
    'ATRIA INSTITUTE OF TECHNOLOGY',
    'B.M.S.COLLEGE OF ENGINEERING',
    'BANGALORE COLLEGE OF ENGINEERING & TECHNOLOGY',
    'BANGALORE INSTITUTE OF TECHNOLOGY',
    'BANGALORE TECHNOLOGICAL INSTITUTE',
    'BASAVA ACADEMY OF ENGINEERING',
    'BMS College of Engineering',
    'BMS INSTITUTE OF TECHNOLOGY & MANAGEMENT',
    'BMS INSTITUTE OF TECHNOLOGY AND MANGEMENT',
    'BNM INSTITUTE OF TECHNOLOGY',
    'BRINDAVAN COLLEGE OF ENGINEERING',
    'BTL INSTITUTE OF TECHNOLOGY AND MANAGEMENT',
    'CAMBRIDGE INSTITUTE OF TECHNOLOGY',
    'Christ University',
    'CITY ENGINEERING COLLEGE',
    'CMR INSTITUTE OF TECHNOLOGY',
    'DAYANANDA SAGAR ACADEMY OF TECHNOLOGY & MANAGEMENT TECHNICAL CAMPUS',
    'DAYANANDA SAGAR COLLEGE OF ENGINEERING',
    'DON BOSCO INSTITUTE OF TECHNOLOGY',
    'DR. AMBEDKAR INSTITUTE OF TECHNOLOGY',
    'DR.SRI SRI SRI SHIVAKUMARA MAHASWAMY COLLEGE OF ENGINEERING',
    'EAST POINT COLLEGE OF ENGINEERING & TECHNOLOGY',
    'EAST WEST COLLEGE OF ENGINEERING',
    'EAST WEST INSTITUTE OF TECHNOLOGY',
    'GLOBAL ACADEMY OF TECHNOLOGY',
    'GOPALAN COLLEGE OF ENGINEERING AND MANAGEMENT',
    'GOVERNMENT S. K. S. J. T. INSTITUTE',
    'GOVT.TOOLROOM AND TRAINING CENTRE,BANGALORE',
    'GSS Institute of Technology (GSSIT)',
    'GSSS INSTITUTE OF ENGINEERING & TECHNOLOGY FOR WOMEN',
    'HKBK COLLEGE OF ENGINEERING',
    'IIT-Dharwad',
    'IMPACT COLLEGE OF ENGINEERING AND APPLIED SCIENCES',
    'ISLAMIAH INSTITUE OF TECHNOLOGY, BANGALORE',
    'JAIN UNIVERSITY( SRI BHAGWAN MAHAVEER JAIN COLLEGE)',
    'Janatha Edu Trust\'s Vivekananda Institute of Technology (VIT)',
    'JSS ACADEMY OF TECHNICAL EDUCATION',
    'JYOTHY INSTITUTE OF TECHNOLOGY',
    'K.N.S. INSTITUTE OF TECHNOLOGY, BANGALORE-64',
    'K.S. SCHOOL OF ENGINEERING AND MANAGEMENT',
    'K.S.INSTITUTE OF TECHNOLOGY',
    'Kammavari Sangha\'s Institute of Technology (KSIT)',
    'M S ENGINEERING COLLEGE',
    'M. N. Technical Institute, Bangalore',
    'M. S. RAMAIAH INSTITUTE OF TECHNOLOGY',
    'MAHARAJA INSTITUTE OF TECHNOLOGY THANDAVAPURA',
    'MS Engineering College',
    'MS RAMAIAH INSTITUTE OF TECHNOLOGY',
    'MVJ COLLEGE OF ENGINEERING',
    'MYSORE COLLEGE OF ENGINEERING AND MANAGEMENT',
    'NADGIR INSTITUTE OF ENGINEERING AND TECHNOLOGY',
    'NAGARJUNA COOLEGE OF ENGINEERING & TECHNOLOGY',
    'NANDI INSTITUTE OF TECHNOLOGY AND MANAGEMENT SCIENCES',
    'NEW HORIZON COLLEGE OF ENGINEERING (E&T)',
    'NIE INSTITUTE OF TECHNOLOGY',
    'NITTE MEENAKSHI INSTITUTE OF TECHNOLOGY',
    'P.N.S Womens Institute of Technology (PNSWIT)',
    'PES INSTITUTE OF TECHNOLOGY, BANGALORE SOUTH CAMPUS',
    'PES UNIVERSITY',
    'PNS INSTITUTE OF TECHNOLOGY',
    'R. R. INSTITUTE OF TECHNOLOGY',
    'R.L.JALAPPA INSTITUTE OF TECHNOLOGY',
    'R.V. COLLEGE OF ENGINEERING',
    'RAJARAJESWARI COLLEGE OF ENGINEERING',
    'RAJIV GANDHI INSTITUTE OF TECHNOLOGY',
    'Reva Institute Of Technology & Management',
    'RNS INSTITUTE OF TECHNOLOGY',
    'RR Institutions Engineering colleges in Bangalore',
    'S. E. A. COLLEGE OF ENGINEERING & TECHNOLOGY',
    'S.K.S.J.T Institute ',
    'SAI VIDYA INSTITUTE OF TECHNOLOGY',
    'SAMBHRAM INSTITUTE OF TECHNOLOGY',
    'SAPTHAGIRI COLLEGE OF ENGINEERING',
    'SCT Institute Of Technology',
    'SHRI PILLAPPA COLLEGE OF ENGINEERING',
    'SIR M. VISVESVARAYA INSTITUTE OF TECHNOLOGY',
    'SIR M.VISVESVARAYA INSTITUTE OF TECHNOLOGY',
    'SJB INSTITUTE OF TECHNOLOGY',
    'Sri Channabasaveshvara Intitute Of Technology',
    'SRI JAYACHAMARAJENDRA COLLEGE OF ENGINEERING',
    'SRI KRISHNA INSTITUTE OF TECHNOLOGY',
    'Sri Rajarajeshwari College Of Engineering',
    'SRI REVANA SIDDESHWARA INSTITUTE OF TECHNOLOGY',
    'SRI SAIRAM COLLEGE OF ENGINEERING',
    'SRI VENKATESHWARA COLLEGE OF ENGINEERING',
    'SRI VIDYA VINAYAKA INSTITUTE OF TECHNOLOGY',
    'T JOHN INSTITUTE OF TECHNOLOGY',
    'THE NATIONAL INSTITUTE OF ENGINEERING',
    'THE OXFORD COLLEGE OF ENGINEERING',
    'UNIVERSITY VISVESVARAYA COLLEGE OF ENGINEERING',
    'VEMANA INSTITUTE OF TECHNOLOGY',
    'VIDYA VIKAS INSTITUTE OF ENGINEERING & TECHNOLOGY',
    'VIDYAVARDHAKA COLLEGE OF ENGINEERING',
    'VIJAYA VITTALA INSTITUTE OF TECHNOLOGY',
    'VIVEKANANDA INSTITUTE OF TECHNOLOGY',
    'YELLAMMA DASAPPA INSTITUTE OF TECHNOLOGY'
  ]


// WEBPACK FOOTER //
// ./src/utils/collegesName.js